import { Disclosure } from '@headlessui/react';

import arrowbar from '../../../assets/images/arrow-bar.png';
import { useAppSelector } from '../../../redux/store/hooks';
import HtmlToPlainText from '../../../utils/HTMLtoPlainText';
import { renderHtmlWithTeX } from '../../../utils/RenderQuestionWithTex';

const Explanation = () => {
  // Cloud prep test data
  const { selectedTestData } = useAppSelector(state => state.root.cloudPrep);
  const { qId, resultById, testDetailsUnavailable } = useAppSelector(
    state => state.root.startFulltest
  );

  const allSections = resultById?.testDTO?.examPatternDTO?.rounds[0]?.sections;

  const currentSection = allSections?.find(
    (section: any) => section.sectionId === qId?.sectionId
  );

  const currentQuestion =
    currentSection?.generatedSectionQuestions?.[qId?.questionIndex];

  const sectionAnswers =
    resultById?.answers?.[currentQuestion?.sectionId] || [];
  const matchingAnswer = sectionAnswers?.find(
    (ans: any) => ans?.questionId === currentQuestion?.id
  );

  return (
    <div>
      <Disclosure defaultOpen>
        {({ open }) => (
          <div>
            <div className='flex items-center justify-between text-primary'>
              <h3 className='text-lg font-medium'>
                {currentQuestion?.isProgrammingQuestion
                  ? 'What Went Wrong'
                  : 'Explanation'}{' '}
              </h3>
              <Disclosure.Button className='flex items-center space-x-2 text-primary'>
                <img
                  src={arrowbar}
                  alt='arrowbar'
                  className={`transform transition-transform ${
                    open ? 'rotate-180' : ''
                  }`}
                />
              </Disclosure.Button>
            </div>

            <Disclosure.Panel>
              <div className='rounded-xl py-2 leading-[21.6px]'>
                {currentQuestion?.explanation && (
                  <span>
                    {renderHtmlWithTeX(currentQuestion?.explanation, false)}
                  </span>
                )}
                {matchingAnswer?.explanation && (
                  <HtmlToPlainText htmlContent={matchingAnswer?.explanation} />
                )}
                {!matchingAnswer?.explanation &&
                  !currentQuestion?.explanation &&
                  (testDetailsUnavailable
                    ? 'Explanation is not available for this account.'
                    : 'No explanation available')}
              </div>
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
    </div>
  );
};

export default Explanation;
